import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

// Thunk to fetch user profile data
export const fetchUserProfile = createAsyncThunk(
  'user/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/profile`);
      return response.data.data; // Return only the 'data' part
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Thunk to update the user profile
export const updateUserProfile = createAsyncThunk(
  'user/updateProfile',
  async (profileData, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/profile`, profileData);
      return response.data; // Return response
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const changeUserPassword = createAsyncThunk(
  'user/changePassword',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/change-password`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

const initialState = {
  profile: {},
  isLoading: false,
  errorMessage: '',
  successMessage: '',
};

const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    clearMessage: (state, action) => {
      state.successMessage = '';
      state.errorMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.profile = action.payload;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.payload;
      })
      .addCase(updateUserProfile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successMessage = 'Profile updated successfully!';
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.payload;
      })
      .addCase(changeUserPassword.pending, (state) => {
        state.isLoading = true;
        state.successMessage = '';
        state.errorMessage = '';
      })
      .addCase(changeUserPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successMessage = 'Password changed successfully!';
      })
      .addCase(changeUserPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.payload.message || 'Something went wrong!';
      });
  },
});

export const { clearMessage } = configurationSlice.actions;

export default configurationSlice.reducer;
